// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__3sXI3","fadein":"Main_fadein__28Ioq"};